exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dash-banner-index[data-v-61a1fafc]{text-align:center;border-radius:4px!important}.dash-banner-index img[data-v-61a1fafc]{border-radius:4px!important;width:350px;height:260px}.dash-banner-index a[data-v-61a1fafc]{cursor:default;border-radius:4px!important;width:100%;display:block!important;height:auto!important;margin:0!important;padding:0!important}.dash-banner-index a[href][data-v-61a1fafc]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61a1fafc","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/banners/RightBannerCard.vue
// module id = G3pn
// module chunks = 0